import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import AboutUs from './pages/About/AboutUs';
import MissionVision from './pages/About/MissionVision';
import History from './pages/About/History';
import WhyChooseUs from './pages/About/WhyChooseUs';
import Services from './pages/Services/Services';
import CoachingPrograms from './pages/Services/CoachingPrograms';
import Facilities from './pages/Services/Facilities';
import Membership from './pages/Services/Membership';
import OurStaff from './pages/OurStaff/OurStaff';
import Testimonials from './pages/Testimonials/Testimonials';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';
import Events from './pages/Events/Events';
import Contact from './pages/Contact/Contact';
import ScrollToTop from './components/ScrollToTop';
import BeginnerTraining from './pages/Services/beginnertraining';
import IntermediateCoaching1 from './pages/Services/IntermediateCoaching1';
import AdvancedTraining from './pages/Services/advancedtraining';
import ProfessionalCoaching from './pages/Services/ProfessionalCoaching';
import KidsPrograms from './pages/Services/KidsPrograms';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/about/mission-vision" element={<MissionVision />} />
          <Route path="/about/history" element={<History />} />
          <Route path="/about/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/coaching-programs" element={<CoachingPrograms />} />
          <Route path="/services/facilities" element={<Facilities />} />
          <Route path="/services/membership" element={<Membership />} />
          <Route path="/our-staff" element={<OurStaff />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/beginner-training" element={<BeginnerTraining />} />
          <Route path="/intermediate-coaching" element={<IntermediateCoaching1 />} />
          <Route path="/Advanced-Training" element={<AdvancedTraining />} />
          <Route path="/Professional-Coaching" element={<ProfessionalCoaching />} />
          <Route path="/Kids-Programs" element={<KidsPrograms />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
